export default "__VITE_ASSET__7c0fe901__"